function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import propTypes from 'prop-types';
import { getEntityRegistration } from '@shared/utils/entityRegistration';
import { routes } from '@shared/routerHistory';
import { Constants } from '@shared/utils/constants';
import { PartnerSearchResultType } from '@shared/Models';
import { logger } from '@src/logger';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';
import { getWindow } from '@shared/services/window';
import { setSuggestionsRequestId } from 'actions/actions';
import { getNpsModule } from '@appsource/utils/nps';
import RemoteAppSourceHeader from '@layout/Header';
import { generateUrlNavigation } from './Navigation';
const RemoteHeader = ({ market, locale, userProps, onMarketChange, onLocaleChange }, context)=>{
    const { buildHref } = context;
    const activeFilters = useSelector((state)=>state.apps.activeFilters.filter((activeFilter)=>Boolean(activeFilter.BackendKey)));
    const unifiedExperience = useSelector(({ config })=>config.isConverged);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const handleNavigation = (options)=>{
        var _getNpsModule;
        const url = generateUrlNavigation(buildHref, options);
        if (url) {
            navigate(url);
        }
        (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.increaseActionsCounter(Constants.NpsActions.galleryChangesCount);
        getWindow().scrollTo(0, 0);
    };
    const handleSearch = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*(options) {
            var _getEntityRegistration;
            const { gallery, searchTerm, useCurrentFilters, suggestionsRequestId } = options;
            const entityType = Constants.EntityType[`${gallery}`];
            const isPartner = entityType === Constants.EntityType.Partner;
            const route = isPartner ? routes.marketplacePartnerSuggestion : (_getEntityRegistration = getEntityRegistration(entityType)) === null || _getEntityRegistration === void 0 ? void 0 : _getEntityRegistration.route;
            if (!route) {
                return;
            }
            if (isPartner) {
                const url = buildHref(route, null, {
                    text: searchTerm,
                    type: PartnerSearchResultType.FreeText.toString(),
                    value: searchTerm
                });
                navigate(url);
                return;
            }
            yield dispatch(setSuggestionsRequestId({
                suggestionsRequestId
            }));
            if (useCurrentFilters) {
                const url = buildHref(route, null, {
                    search: searchTerm,
                    page: '1'
                });
                navigate(url);
                return;
            }
            const url = buildHref(route, null, {
                search: searchTerm,
                page: '1',
                [Constants.FilterQuery.category]: null,
                [Constants.FilterQuery.industry]: null,
                [Constants.FilterQuery.subcategories]: null,
                [Constants.FilterQuery.subindustries]: null,
                [Constants.FilterQuery.product]: null,
                [Constants.FilterQuery.filters]: null,
                serviceType: null
            });
            navigate(url);
        });
        return function handleSearch(options) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx(RemoteAppSourceHeader, {
        userProps: userProps,
        navigate: handleNavigation,
        logger: logger,
        market: market,
        locale: locale,
        searchProps: {
            onSearch: handleSearch,
            filters: activeFilters
        },
        location: location,
        onMarketChange: onMarketChange,
        onLocaleChange: onLocaleChange,
        unifiedExperience: unifiedExperience
    });
};
RemoteHeader.contextTypes = {
    buildHref: propTypes.func
};
export default RemoteHeader;
